import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { StoryListing } from '@/mocks/weddingStories'

interface StoryCardProps {
  story: StoryListing
}

export default function StoryCard({ story }: StoryCardProps) {
  const { t } = useTranslation()

  return (
    <Link
      to={story.to}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 cursor-pointer hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
        <img
          src={story.coverImage}
          alt={`${story.couple} — ${story.type} in ${story.place} photographed by Shabi Media`}
          title={`${story.couple} | Shabi Media wedding photography, ${story.place}`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 h-7 px-3 rounded-full bg-background-50/90 backdrop-blur-sm text-[11px] font-medium tracking-wide text-primary-700">
          <i className="ri-heart-3-line text-xs" />
          {story.type}
        </span>
      </div>

      <div className="flex flex-col flex-1 p-5 md:p-6">
        <div className="flex flex-wrap items-center gap-2 text-[11px] tracking-[0.14em] uppercase text-foreground-500 mb-3">
          <i className="ri-map-pin-2-line text-sm text-accent-600" />
          <span>{story.place}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300" />
          <span>{story.date}</span>
        </div>
        <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 leading-snug">
          {story.couple}
        </h3>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{story.excerpt}</p>
        <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-700 group-hover:text-primary-600 transition-colors">
          {t('weddingStories.readStory')}
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  )
}